export default {
  notMe: 'Aren\'t you {name}?',
  login: 'Log in',
  actual: 'English'
}
